import Vue from 'vue'

// axios
import axios from 'axios'
import getAPIDomain from '@/utils/apiDomain/apiDomain'

const clientApi = getAPIDomain()

const axiosIns = axios.create({
  baseURL: clientApi,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
})

Vue.prototype.$http = axiosIns

export default axiosIns
